'use client';

import { useEffect, useState } from 'react';
import { Heart } from 'lucide-react';

export default function PostLikeCount({ postId, initialCount }: { postId: string; initialCount: number }) {
  const [count, setCount] = useState(initialCount);
  useEffect(() => {
    const update = (event: Event) => {
      const detail = (event as CustomEvent<{ postId: string; delta: number }>).detail;
      if (detail?.postId === postId) setCount(value => Math.max(0, value + detail.delta));
    };
    window.addEventListener('gamekee-post-like-changed', update);
    return () => window.removeEventListener('gamekee-post-like-changed', update);
  }, [postId]);
  return <span><Heart aria-hidden="true" size={17} /> {count}</span>;
}
